import * as React from 'react';

import IconFolderCollab from '../folder/IconFolderCollab';
import IconFolderExternal from '../folder/IconFolderExternal';
import IconFolderPersonal from '../folder/IconFolderPersonal';

var FolderIcon = function FolderIcon(_ref) {
    var _ref$dimension = _ref.dimension,
        dimension = _ref$dimension === undefined ? 32 : _ref$dimension,
        _ref$isCollab = _ref.isCollab,
        isCollab = _ref$isCollab === undefined ? false : _ref$isCollab,
        _ref$isExternal = _ref.isExternal,
        isExternal = _ref$isExternal === undefined ? false : _ref$isExternal,
        title = _ref.title;

    if (isExternal) {
        return React.createElement(IconFolderExternal, {
            height: dimension,
            width: dimension,
            title: title
        });
    }

    if (isCollab) {
        return React.createElement(IconFolderCollab, {
            height: dimension,
            width: dimension,
            title: title
        });
    }

    return React.createElement(IconFolderPersonal, {
        height: dimension,
        width: dimension,
        title: title
    });
};

FolderIcon.propTypes = {
    /** Dimension of the icon */
    dimension: PropTypes.number,

    /** If true displays collaborated folder icon */
    isCollab: PropTypes.bool,

    /** If true displays externally collaborated folder icon */
    isExternal: PropTypes.bool,

    /** A text-only string describing the icon if it's not purely decorative for accessibility */
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};
export default FolderIcon;
import PropTypes from 'prop-types';